/**
 * Application shell: error boundary, router, auth, and global UI.
 * The route table lives in src/routes/AppRoutes.js.
 */
import { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./auth";
import SignInPrompt from "./components/auth/SignInPrompt";
import AlertContainer from "./components/common/AlertContainer";
import AppToastProvider from "./components/common/AppToastProvider";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { AppShellSkeleton } from "./components/common/SkeletonLoader";
import ScrollToTop from "./components/navigation/ScrollToTop";
import FcmBootstrap from "./components/notifications/FcmBootstrap";
import { PlatformFeatureFlagsProvider } from "./contexts/PlatformFeatureFlagsContext";
import MaintenanceGate from "./components/common/MaintenanceGate";
import AppRoutes from "./routes/AppRoutes";
import "./styles/themes/variables.css";
import "./App.css";

const PageLoader = () => <AppShellSkeleton message="Loading…" />;

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppToastProvider>
          <ScrollToTop />
          <SignInPrompt />
          <PlatformFeatureFlagsProvider>
            <AuthProvider>
              <FcmBootstrap />
              <AlertContainer />
              <Suspense fallback={<PageLoader />}>
                <MaintenanceGate>
                  <AppRoutes />
                </MaintenanceGate>
              </Suspense>
            </AuthProvider>
          </PlatformFeatureFlagsProvider>
        </AppToastProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
